import styled, { keyframes, css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

const MIN_WIDTH = '1135px';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const ScrollContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	padding: 0 32px;
`;

const fadeAnimation = keyframes`
 	0% { opacity: 0; }
 	100% { opacity: 1; }
`;

export const FixedHeader = styled.div`
	position: fixed;
	z-index: 2;
	background-color: white;
	width: 100%;
	animation: ${fadeAnimation} 0.3s ease;
	display: flex;
	align-items: center;
	height: 48px;
	margin-left: -32px;
	padding-left: 32px;
`;

export const OrderedItemWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;

	${({ order }) =>
		order &&
		css`
			order: ${order};
		`};
`;

export const SecondaryContent = styled.div`
	min-width: ${MIN_WIDTH};
	background-color: ${colors.greyBg};
	padding: 32px;
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 -32px;
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: ${MIN_WIDTH};
	height: auto;
	padding: 24px 32px;
	background-color: ${colors.white};
	margin-bottom: 32px;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
